import React, { useState } from 'react';

const Projects = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const projects = [
    {
      id: 1,
      title: "Under Construction",
      category: "all",
      description: "We're busy building out our projects page. Check back soon for updates!",
      image: require('../static/images/construction.png'),
      technologies: ["React", "Fast API", "Python", "Node.js"],
      status: "In Development"
    }
  ];

  const filters = [
    { key: 'all', label: 'All Projects' },
    { key: 'healthcare', label: 'Healthcare' },
    { key: 'research', label: 'Research' },
    { key: 'platform', label: 'Platform' }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  const getStatusColor = (status) => {
    switch (status) {
      case 'Live': return 'status-live';
      case 'Beta Testing': return 'status-beta';
      case 'Pilot Program': return 'status-pilot';
      case 'In Development': return 'status-development';
      case 'Research Phase': return 'status-research';
      default: return 'status-default';
    }
  };

  return (
    <div className="page-container">
      <div className="page-content">
        <div className="hero-section">
          <h1>Our Projects</h1>
          <p className="hero-subtitle">
            Building the future of healthcare, one DIV at a time.
          </p>
        </div>

        <div className="filter-section">
          <div className="filter-buttons">
            {filters.map(filter => (
              <button
                key={filter.key}
                className={`filter-btn ${activeFilter === filter.key ? 'active' : ''}`}
                onClick={() => setActiveFilter(filter.key)}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </div>

        <div className="projects-grid">
          {filteredProjects.map(project => (
            <div key={project.id} className="project-card">
              <div className="project-image">
                <img src={project.image} alt={project.title} />
                <div className={`project-status ${getStatusColor(project.status)}`}>
                  {project.status}
                </div>
              </div>
              
              <div className="project-content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                
                <div className="project-technologies">
                  {project.technologies.map(tech => (
                    <span key={tech} className="tech-tag">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;